import { withInstall } from '@ll-plus/utils'

import ColorPicker from './src/color-picker.vue'
import Color from './src/config/color'

export const LlColorPicker = withInstall(ColorPicker)
export default LlColorPicker
export * from './src/config/index'
export { Color }
declare module 'vue' {
  export interface GlobalComponents {
    LlColorPicker: typeof ColorPicker
  }
}
